const APP_EVENT = 'trackCustomEvent';

// trigger custom event
// apphub will capture and push this to sensor
export const appTracker = ({ name, data }: { name: string; data: any }) => {
  const eventObject: any = new CustomEvent(APP_EVENT, {
    detail: {
      name: name,
      data: JSON.stringify(data),
    },
  });
  document.dispatchEvent(eventObject);
};

export default appTracker;
